module.exports = __webpack_public_path__ + "media/components/assets/recycling_04-12dc6ee885803b8dba9ab764e9d11686.jpg";